
import { INode } from "@/types/INode";
import { Component, Vue, Prop } from "vue-property-decorator";
import Clip from "./Clip";
import  ButtonVue from "@/lib/Button.vue";
import Bus from "@/lib/Bus"; const bus: Bus = new Bus().getBus(); 

@Component({ components: { ButtonVue} })
export default class ClipUseVue extends Vue {
  public static clip:Clip=new Clip().getClip(); 
  @Prop(String) type:string|undefined;
  @Prop(String) title:string|undefined;

  key=0
  full_title:string=""
  node:INode|undefined;

  created() {
    bus.register("clipboard_changed",this.clipboard_changed)
  }

  beforeDestroy() {
    bus.remove("clipboard_changed",this.clipboard_changed)
  }
  clipboard_changed() { this.refresh() }

  del(node:INode) {
    if (node) {
      ClipUseVue.clip.del(node);
      alert('Usunięto z notatnika '+node.idn)
      this.key++
    }
  }

  use(node:INode) {
    if (node) {
      this.$emit('clipboard_use', node)
      //ClipUseVue.clip.del(node);
    }
  }


  refresh() {
    if( this.type && ClipUseVue.clip) {

      this.node=ClipUseVue.clip.nodes[this.type];
      if (this.node) {
        if (this.node.idn) {
          this.full_title = this.node.idn;
        } else {
          if (Array.isArray(this.node)) {
            for (let i=0;i<this.node.length;i++) {
              if (i>0) this.full_title+=", "
              this.full_title+=this.node[i].idn
            }
          }
        }
      } else {
        this.full_title = ""
      }
      this.key++
    } 
  }

  mounted() {
    this.refresh()
  }
}
